{
  "select_date": "日付を選択"
}
